export class Message
{
	messageId: number;
	createDate: Date;
	lastUpdate: Date;
	sendDate: Date;
	receiveDate: Date;
	messageType: string;
	sendByText: boolean;
	sendByEmail: boolean;
	messageStatus: string;
	message: string;
	toFirstName: string;
	toLastName: string;
	toEmailAddress: string;
	toPhoneNumber: string;
	toPhoneCountryCode: string;
	toSubject: string;
	confirmationId: string;
	opsNotes: string;
	debug: string;
}
